<template>
  <div class="bottom-nav">
    <div 
      class="nav-item" 
      :class="{ active: isActive('/home') }"
      @click="navigateTo('/home')"
    >
      <img 
        :src="isActive('/home') ? require('@/assets/home-icon-selected.png') : require('@/assets/home-icon.png')" 
        alt="home" 
        class="nav-icon" 
      />
      <span>首页</span>
    </div>
    <div 
      class="nav-item"
      :class="{ active: isActive('/account') }"
      @click="navigateTo('/account')"
    >
      <img 
        :src="isActive('/account') ? require('@/assets/user-icon-selected.png') : require('@/assets/user-icon.png')" 
        alt="account" 
        class="nav-icon" 
      />
      <span>我的</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BottomNav',
  methods: {
    isActive(path) {
      return this.$route.path === path;
    },
    navigateTo(path) {
      if (this.$route.path !== path) {
        this.$router.push(path);
      }
    }
  }
};
</script>

<style scoped>
.bottom-nav {
  height: 60px;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  background-color: #191919;
  border-top: 1px solid #2a2a2a;
  align-items: center;
  justify-content: center;
}

.nav-item {
  flex: 1;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  font-size: 12px;
  color: #999;
  cursor: pointer;
}

.nav-item.active {
  color: #36D8AF;
}

.nav-icon {
  width: 20px;
  height: 20px;
}
</style>
